export default "__VITE_ASSET__DsIMT44X__"